import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogActions, Button, Grid, TextField, DialogTitle, Divider, Typography, } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { submitOverrideCaseSla } from "../../../../redux/actions";
import { useFormState } from "../../../../hooks/useFormState";
import { SelectListField } from "../../../common/SelectListField";
import { activitiesService, slaReasonService } from "../../../../services";
const MULTILINE_ROW_HEIGHT = 8;
export const SlaOverrideDialog = ({ isDialogOpen, onDialogClose, caseModel, }) => {
    const dispatch = useDispatch();
    const [activity, setActivity] = useState([]);
    useEffect(() => {
        activitiesService
            .getLatestSlaActivity(caseModel.id)
            .then(response => setActivity(response.eventMeta));
    }, [caseModel.id]);
    const isPaused = caseModel.slaPaused;
    const { formProps, triggerSubmit, triggerReset } = useFormState({
        noteBody: "",
        reason: "",
    }, isPaused ? [] : ["reason"], ({ state }) => {
        if (isPaused) {
            state.values.reason = activity.reason;
        }
        dispatch(submitOverrideCaseSla(caseModel.id, Object.assign({}, state.values), isPaused));
        onDialogClose();
        triggerReset();
    });
    return (activity && (React.createElement(Dialog, { open: isDialogOpen, onClose: () => {
            onDialogClose();
            triggerReset();
        }, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, isPaused ? "Restart SLA" : "Pause SLA"),
        React.createElement(Divider, null),
        React.createElement(DialogContent, null,
            React.createElement("form", null,
                React.createElement(Grid, { container: true, spacing: 3 },
                    !isPaused ? (React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(SelectListField, Object.assign({}, formProps("reason"), { label: "Reason", service: slaReasonService })))) : (React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(Typography, { variant: "body1" },
                            "Pause reason: ",
                            activity.reason))),
                    React.createElement(Grid, { item: true, xs: 12, sm: 12 },
                        React.createElement(TextField, Object.assign({ variant: "outlined" }, formProps("noteBody"), { label: "Note", fullWidth: true, multiline: true, rows: MULTILINE_ROW_HEIGHT })))))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => triggerSubmit(), "data-test": "dialog-ok", color: "primary" }, "Confirm")))));
};
